import React, { useState, useEffect } from "react";

// import assets
import OneTimeIcon from "../../../assets/loanPrograms/Onetimeclose.png";
import TwoTimeIcon from "../../../assets/loanPrograms/Two-Time_Close_Construction_Home_Loans.png";
import FHACIcon from "../../../assets/loanPrograms/FHA_Construction_Home_Loans.png";
import VAConstructionIcon from "../../../assets/loanPrograms/VA_Construction_Home_Loans.png";
import ConstBridgeIcon from "../../../assets/loanPrograms/Construction_Bridge_Loan.png";


const index = ({ program, title }) => {
  const loanPrograms = [
    {
      imageUrl: OneTimeIcon,
      title: "One-Time Close Construction Home Loans",
      description:
        "Save money with only one appraisal and set of closing costs. Rates are locked in prior to closing, with final terms converted to permanent terms once construction is finalized.",
    },
    {
      imageUrl: TwoTimeIcon,
      title: "Two-Time Close Construction Home Loans",
      description:
        "Use one mortgage to finance the lot to build on, and then one for the construction and long-term financing, with the potential to obtain lower rates.",
    },
    {
      imageUrl: FHACIcon,
      title: "FHA Construction Home Loans",
      description:
        "FHA Construction home loans are for those with lower down payments, higher debt-to-income ratios, or credit challenges. Allow for as little as 3.5% down. ",
    },
    {
      imageUrl: VAConstructionIcon,
      title: "VA Construction Home Loans",
      description:
        "Get the same benefits as a VA Home Loan, including 0% down, but build your dream home! ",
    },
    {
      imageUrl: ConstBridgeIcon,
      title: "Construction Bridge Loan",
      description:
        "Stay in your current home during the construction of your new home.",
    },
  ];
  return (
    <div
      id="nav-loanprograms"
      className="mx-auto pt-8 pb-14 bg-gray-100 md:px-24"
    >
      <h2 className="font-bold text-center pt-16 pb-10">
        Construction Loan <span className="block sm:inline">Programs</span>
      </h2>

      <div className="grid lg:grid-cols-3 gap-4 max-w-[1350px] mx-auto">
        {loanPrograms.map((loan, index) => (
          <div
            key={index}
            className="flex flex-col items-center p-4 px-24 my-12"
          >
            <img
              src={loan.imageUrl}
              alt={loan.title}
              className="h-auto w-[150px] mb-6"
            />
            <h2 className="text-4xl font-bold mb-6 text-center">
              {loan.title}
            </h2>
            <p className="text-md text-center">{loan.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default index;
